import React from 'react';
import styled from 'styled-components/macro';

import { Loader } from 'web-ui-kit/loading';
import ProgressBar from 'web-ui-kit/progressBar';
import { H4, H7, semiBold } from 'web-ui-kit/heading';
import { Box } from 'web-ui-kit/containers';
import { white } from 'web-ui-kit/colors';
import { DisplayToggle, MQ_FOR_PHONE_ONLY, QUERY_FOR_PHONE_ONLY } from 'web-ui-kit/media';

const LoadingContainer = styled(Box)`
  position: relative;
  width: 100%;
`;

const BarContainer = styled(Box)`
  width: 100%;
  margin-top: 80px;

  ${MQ_FOR_PHONE_ONLY} {
    margin-top: 40px;
  }
`;

const Title = styled(H4)`
  margin-top: 64px;
`;

const BoldTitle = styled(H4)`
  font-weight: ${semiBold};
  margin-top: 96px;
`;

const Overlay = styled.div`
  ${props => !props.transparent && `
    width: 100%;
    height: 100%;
    background: ${white};
  `}
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 100vw;
  max-height: 100vh;
  overflow: auto;
  box-shadow: 0 0 0 60vmax rgba(0, 0, 0, 0.5), 0 0 32px rgba(0, 0, 0, 0.25);

  z-index: 9999
`;

const TitleOverlay = styled(Overlay)`
  height: 613px;
  width: calc(100% - 32px);
  max-width: 938px;
  text-align: center;
  padding: 240px 121px 142px 121px;
  margin: 16px auto;
  background: ${white};

  ${MQ_FOR_PHONE_ONLY} {
    height: 365px;
    maxWidth: 329px;
    padding: 166px 50px 60px 50px;
  }
`;

const Fixed = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9998;
  background: ${props => props.background};
`;

export default function LoadingOverlay ({progressBar, title1, title2, isSmallScreen, transparent = true}) {
  if (title1) {
    return (
      <div>
        <TitleOverlay>
          <LoadingContainer>
            <Loader position={'absolute'} />
          </LoadingContainer>

          <DisplayToggle query={QUERY_FOR_PHONE_ONLY}>
            <BoldTitle>{`${title1}  ${title2}`}</BoldTitle>
            <React.Fragment><Title>{title1}</Title><H7>{title2}</H7></React.Fragment>
          </DisplayToggle>

          <BarContainer>
            {(typeof progressBar !== 'undefined') && <ProgressBar percentage={progressBar} />}
          </BarContainer>
        </TitleOverlay>
        <Fixed
          onClick={e => false}
          background={'url(data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7)'}
        />
      </div>
    );
  }

  return (
    <div>
      <Overlay transparent={transparent} />
      <Loader />
      <Fixed
        onClick={e => false}
        background={'url(data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7)'}
      />
    </div>
  );
}
